import { Component } from '@angular/core';
import { FeedbackPlatformReviewAssignmentEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Review Assignments') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-feedbackplatformreviewassignment-form',
    templateUrl: './feedbackplatformreviewassignment.form.component.html'
})
export class FeedbackPlatformReviewAssignmentFormComponent extends BaseFormComponent {
    public record!: FeedbackPlatformReviewAssignmentEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'reviews', sectionName: 'Reviews', isExpanded: false }
        ]);
    }
}

